import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { ProgressSpinnerModule } from 'primeng/progressspinner'

/**
 * Placeholder shown at `/login/callback` while `AppConfigService.Init()`
 * handles the Okta redirect and routes the user on to `/` (on success) or
 * `/login` (on failure).
 *
 * The real token-exchange work happens in `AppConfigService.Init()` because
 * it runs as an APP_INITIALIZER, before Angular's first navigation. This
 * component is intentionally UI-only so it can't interfere with that flow.
 */
@Component({
  selector: 'app-okta-callback',
  imports: [TranslatePipe, ProgressSpinnerModule],
  templateUrl: './okta-callback.component.html',
  styleUrl: './okta-callback.component.scss'
})
export class OktaCallbackComponent {}
